const collectionGrid = document.querySelector(".collection-grid");
if (collectionGrid) {
  collectionGrid.addEventListener("click", (e) => {
    const inputPagination = document.getElementById("input-pagination");
    const goToLink = document.querySelector(".go-to-link");

    if (inputPagination) {
      inputPagination.addEventListener("input", () => {
        goToLink.setAttribute("href", `?page=${inputPagination.value}`);
      });
      inputPagination.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          goToLink.click();
          e.preventDefault();
        }
      });
    }

    if (e.target.classList.contains("toggle-btn")) {
      const filterContainer = document.querySelector(".filter-container");
      if (
        !filterContainer.classList.contains(
          "filter-container--show-filters-desktop"
        ) ||
        !filterContainer.classList.contains(
          "filter-container--show-filters-mobile"
        )
      ) {
        document.querySelector(".product-list").classList.add("toggled");
      } else {
        document.querySelector(".product-list").classList.remove("toggled");
      }
    }
  });
}

const backToTopBtn = document.querySelector(".back-to-top");

window.addEventListener("scroll", () => {
  if (
    document.body.scrollTop > 120 ||
    document.documentElement.scrollTop > 120
  ) {
    backToTopBtn.classList.add("visible");
  } else {
    backToTopBtn.classList.remove("visible");
  }
});

backToTopBtn.addEventListener("click", () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});

